"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsRecognizerExerciseHandler = void 0;
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const DefaultCardsExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/DefaultCardsExerciseHandler");
class CardsRecognizerExerciseHandler extends DefaultCardsExerciseHandler_1.DefaultCardsExerciseHandler {
    handleRecognizeEvent(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const words = ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.word) || [];
            console.log('word: ', words);
            const recognized = this.recognizedWords.concat([words.join(' ')]);
            this.dispatch((0, exercise_js_1.setRecognizedWords)(recognized));
            if (!this.isChecked && !this.answers[this.currentIndex])
                yield this.handleAnswer(words);
        });
    }
}
exports.CardsRecognizerExerciseHandler = CardsRecognizerExerciseHandler;
